/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// アコーディオン機能
!(function () {
  var ac_toggle = document.querySelectorAll(".c-acordion__toggle");
  function toggle(event) {
    // アコーディオンのコンテンツ内のaタグのクリックは処理しない
    if (event.target.closest(".c-acordion__content a")) {
      return;
    }
    var content = this.nextElementSibling;
    this.classList.toggle("is-active");
    content.classList.toggle("is-open");
  }
  for (let i = 0; i < ac_toggle.length; i++) {
    ac_toggle[i].addEventListener("click", toggle);
  }
})();

// .shopify-email-marketing-confirmation__container内のテキストが「登録解除」と一致する a タグを非表示
!(function () {
  function hideUnsubscribeAnchors() {
    try {
      if (typeof document === "undefined" || !document) return;

      const container = document.querySelector(".shopify-email-marketing-confirmation__container");
      if (!container) return;

      const anchors = container.querySelectorAll("a");
      if (!anchors || anchors.length === 0) return;

      anchors.forEach(function (a) {
        try {
          if (!a || typeof a.textContent === "undefined") return;
          const text = (a.textContent || "").trim();
          if (text === "登録解除") {
            a.style.display = "none";
          }
        } catch (error) {
          // エラーは無視
        }
      });
    } catch (error) {
      // エラーは無視
    }
  }

  if (typeof document !== "undefined" && document) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        setTimeout(hideUnsubscribeAnchors, 100);
      });
    } else {
      setTimeout(hideUnsubscribeAnchors, 100);
    }
  }

  if (typeof window !== "undefined" && window) {
    window.addEventListener("load", function () {
      setTimeout(hideUnsubscribeAnchors, 500);
    });
  }
})();

// .shopify-email-marketing-confirmation__container内の特定<p>を置換
!(function () {
  function replaceEmailMarketingConfirmationText() {
    try {
      if (typeof document === "undefined" || !document) return;

      const container = document.querySelector(".shopify-email-marketing-confirmation__container");
      if (!container) return;

      const paragraphs = container.querySelectorAll("p");
      if (!paragraphs || paragraphs.length === 0) return;

      const targetText = "いつでも登録を解除できます。";
      const replacementText = "登録解除はマイページのアカウント編集より解除登録を行なってください。";

      paragraphs.forEach(function (p) {
        try {
          if (!p || typeof p.textContent === "undefined") return;
          const current = (p.textContent || "").trim();
          if (current === targetText) {
            p.textContent = replacementText;
          }
        } catch (error) {
          // エラーは無視
        }
      });
    } catch (error) {
      // エラーは無視
    }
  }

  // DOMContentLoaded で実行
  if (typeof document !== "undefined" && document) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        setTimeout(replaceEmailMarketingConfirmationText, 100);
      });
    } else {
      setTimeout(replaceEmailMarketingConfirmationText, 100);
    }
  }

  // load 後にも実行（動的挿入への保険）
  if (typeof window !== "undefined" && window) {
    window.addEventListener("load", function () {
      setTimeout(replaceEmailMarketingConfirmationText, 500);
    });
  }
})();

// 374px未満のデバイスのレスポンシブ対応
!(function () {
  const viewport = document.querySelector('meta[name="viewport"]');

  function switchViewport() {
    const value = window.outerWidth > 374 ? "width=device-width,initial-scale=1" : "width=374";

    if (viewport.getAttribute("content") !== value) {
      viewport.setAttribute("content", value);
    }
  }

  addEventListener("resize", switchViewport, false);
  switchViewport();
})();

// サイズテーブル処理機能
!(function () {
  function processSizeTable() {
    const sizeTable = document.querySelector(".c-acordion__table--size");

    if (!sizeTable) return;

    // メタフィールドの内容をdata属性から取得
    const metafieldContent = sizeTable.getAttribute("data-size-data");

    if (!metafieldContent) return;

    // 改行で分割して各行を取得
    const lines = metafieldContent.split("\n").filter((line) => line.trim() !== "");

    if (lines.length < 2) return; // ヘッダーとデータ行が最低限必要

    // テーブルをクリア
    sizeTable.innerHTML = "";

    // ヘッダー行を処理
    const headerCells = lines[0].split(",").map((cell) => cell.trim());
    const headerRow = document.createElement("tr");

    headerCells.forEach((cell) => {
      const th = document.createElement("th");
      th.textContent = cell;
      headerRow.appendChild(th);
    });

    sizeTable.appendChild(headerRow);

    // データ行を処理
    for (let i = 1; i < lines.length; i++) {
      const dataCells = lines[i].split(",").map((cell) => cell.trim());
      const dataRow = document.createElement("tr");

      dataCells.forEach((cell) => {
        const td = document.createElement("td");
        td.textContent = cell;
        dataRow.appendChild(td);
      });

      sizeTable.appendChild(dataRow);
    }
  }

  // DOMContentLoadedイベントで実行
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", processSizeTable);
  } else {
    processSizeTable();
  }
})();

// アコーディオンテーブルのレスポンシブ幅設定
!(function () {
  function setTableWrapper() {
    const sizeTables = document.querySelectorAll(".c-acordion__table--size");

    // より正確な画面幅を取得
    const screenWidth = document.documentElement.clientWidth;

    sizeTables.forEach((table) => {
      // .c-acordion__table--sizeを含む.table-wrapperを探す
      const tableWrapper = table.closest(".table-wrapper");

      if (tableWrapper) {
        if (screenWidth <= 740) {
          // CSS変数からガター値を取得
          const containerGutter = getComputedStyle(document.documentElement).getPropertyValue("--container-gutter");
          const gutterValue = parseFloat(containerGutter) || 0;

          // 画面幅からガター*2を引いた値を計算
          const calculatedWidth = screenWidth - gutterValue * 2;

          // .table-wrapperに横スクロールと幅を設定
          tableWrapper.style.overflowX = "scroll"; // 常時スクロールバー表示
          tableWrapper.style.overflowY = "hidden";
          tableWrapper.style.width = calculatedWidth + "px";
          tableWrapper.style.maxWidth = calculatedWidth + "px";
          tableWrapper.style.setProperty("-webkit-overflow-scrolling", "touch");
          // スクロールバー用の溝を常に確保（対応ブラウザ向け）
          tableWrapper.style.setProperty("scrollbar-gutter", "stable both-edges");
          // SimpleBar属性を付与
          tableWrapper.setAttribute("data-simplebar", "");
          tableWrapper.setAttribute("data-simplebar-auto-hide", "false");

          // テーブル自体にも最小幅を設定
          table.style.minWidth = "600px";
          table.style.width = "600px";
        } else {
          // 740pxより大きい場合はスタイルを削除
          tableWrapper.style.overflowX = "";
          tableWrapper.style.width = "";
          tableWrapper.style.maxWidth = "";
          table.style.minWidth = "";
          table.style.width = "";
        }
      }
    });
  }

  // 初回実行
  setTableWrapper();

  // リサイズイベントで実行
  window.addEventListener("resize", setTableWrapper);

  // DOMContentLoadedイベントでも実行（動的に追加されたテーブルに対応）
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setTableWrapper);
  }
})();

// .wk-product-card .wk-priceからJPY文字列を「税込」に置換
window.addEventListener("load", function () {
  setTimeout(function () {
    const priceElements = document.querySelectorAll(".wk-product-card .wk-price");

    if (priceElements && priceElements.length > 0) {
      priceElements.forEach(function (element) {
        if (!element.innerHTML) return;

        // .wk-current-price.wk-saleが存在するかチェック
        const salePriceElement = element.querySelector(".wk-current-price.wk-sale");

        if (salePriceElement) {
          // .wk-compare-priceに対しては金額表示のみ（JPYを削除）
          const comparePriceElement = element.querySelector(".wk-compare-price");
          if (comparePriceElement && comparePriceElement.innerHTML) {
            comparePriceElement.innerHTML = comparePriceElement.innerHTML.replace(/JPY/g, "");
          }

          // .wk-current-price.wk-saleに対してはJPYを「税込」に置換
          if (salePriceElement.innerHTML) {
            salePriceElement.innerHTML = salePriceElement.innerHTML.replace(/JPY/, '<span class="c-wishlist-product__tax-text">税込</span>');
          }
        } else {
          // .wk-current-price.wk-saleが存在しない場合は現在の処理
          element.innerHTML = element.innerHTML.replace(/JPY/, '<span class="c-wishlist-product__tax-text">税込</span>');
        }
      });
    }
  }, 500);
});

// .cf-reset-password内の「Reset your password」を「パスワードをリセット」に置換
!(function () {
  function replaceResetPasswordText() {
    try {
      // documentが存在しない場合は処理をスキップ
      if (typeof document === "undefined" || !document) {
        return;
      }

      const resetPasswordElements = document.querySelectorAll(".cf-reset-password");

      // 要素が存在しない場合は処理をスキップ
      if (!resetPasswordElements || resetPasswordElements.length === 0) {
        return;
      }

      resetPasswordElements.forEach(function (element) {
        try {
          // 要素が存在し、innerHTMLプロパティがある場合のみ処理
          if (element && typeof element.innerHTML !== "undefined" && element.innerHTML && element.innerHTML.includes("Reset your password")) {
            element.innerHTML = element.innerHTML.replace(/Reset your password/g, "パスワードをリセット");
          }
        } catch (error) {
          // 個々の要素処理でエラーが発生しても処理を継続
        }
      });
    } catch (error) {
      // 全体の処理でエラーが発生してもページに影響を与えない
    }
  }

  // DOMContentLoadedイベントで実行
  if (typeof document !== "undefined" && document) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        setTimeout(replaceResetPasswordText, 100);
      });
    } else {
      setTimeout(replaceResetPasswordText, 100);
    }
  }

  // loadイベントでも実行（動的に追加された要素に対応）
  if (typeof window !== "undefined" && window) {
    window.addEventListener("load", function () {
      setTimeout(replaceResetPasswordText, 500);
    });
  }
})();

// Mega Menu - 独自実装
document.addEventListener("DOMContentLoaded", () => {
  const categoryLinks = document.querySelectorAll(".MegaMenuCategory__TabItem");

  const activateTab = (element) => {
    const parentMenu = element.getAttribute("data-parent-menu");
    if (!parentMenu) return;

    // 同じ親メニュー内のタブをリセット
    document.querySelectorAll(`.MegaMenuCategory__TabItem[data-parent-menu="${parentMenu}"]`).forEach((tab) => tab.classList.remove("is-active"));

    element.classList.add("is-active");

    // 同じ親メニュー内のコンテンツをリセット
    document.querySelectorAll(`.Item__Wrap[data-parent-menu="${parentMenu}"]`).forEach((item) => item.classList.remove("active"));

    const tabIndex = element.getAttribute("data-tab-item");
    const target = document.getElementById(`category-tab-${parentMenu}-${tabIndex}`);
    if (target) {
      target.classList.add("active");
    }
  };

  categoryLinks.forEach((element) => {
    element.addEventListener("mouseover", () => activateTab(element));
    element.addEventListener("click", () => activateTab(element));
  });
});

/* Mega Menu - Auto Height */
document.addEventListener("DOMContentLoaded", () => {
  const setMegaMenuHeight = () => {
    requestAnimationFrame(() => {
      try {
        const header = document.querySelector(".header");
        const announcementBar = document.querySelector(".announcement-bar");
        const megaMenuTabs = document.querySelectorAll(".MegaMenuCategory__Tab");
        const megaMenuContents = document.querySelectorAll(".MegaMenuCategory__Content");

        if (!header || (!megaMenuTabs.length && !megaMenuContents.length)) return;

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        const headerHeight = Math.max(header.offsetHeight || 0, 0);
        const announcementHeight = announcementBar ? Math.max(announcementBar.offsetHeight || 0, 0) : 0;

        const calculatedHeight = scrollTop <= 0 ? window.innerHeight - headerHeight - announcementHeight : window.innerHeight - headerHeight;
        const finalHeight = Math.min(calculatedHeight, 600);

        megaMenuTabs.forEach((tab) => {
          tab.style.height = `${finalHeight}px`;
        });
        megaMenuContents.forEach((content) => {
          content.style.height = `${finalHeight}px`;
        });
      } catch (error) {
        console.warn("Mega Menu height calculation error:", error);
      }
    });
  };

  setMegaMenuHeight();

  const debouncedResize = () => requestAnimationFrame(setMegaMenuHeight);
  window.addEventListener("scroll", debouncedResize);
  window.addEventListener("resize", debouncedResize);
});

/* HeaderメニューでルートURL（/）のリンクを無効化 */
document.addEventListener("DOMContentLoaded", () => {
  const processedLinks = new WeakSet();

  const disableRootLinks = () => {
    // Headerのメニュー内のすべてのaタグを取得
    const headerLinks = document.querySelectorAll(".header__linklist a, .header__linklist-link");

    headerLinks.forEach((link) => {
      // 既に処理済みのリンクはスキップ
      if (processedLinks.has(link)) return;

      const href = link.getAttribute("href");

      // URLがルート（/）の場合、リンクを無効化
      if (href === "/" || href === window.location.origin + "/" || href === window.location.origin) {
        link.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
          },
          { once: false }
        );

        // 視覚的にリンクが無効であることを示す
        link.style.cursor = "default";
        link.style.pointerEvents = "none";

        // 処理済みとしてマーク
        processedLinks.add(link);
      }
    });
  };

  // 初期実行
  disableRootLinks();

  // 動的に追加される要素にも対応（MutationObserver）
  const observer = new MutationObserver(() => {
    disableRootLinks();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

/* MegaMenuCategory__TabLinkのリンクを無効化 */
document.addEventListener("DOMContentLoaded", () => {
  const processedTabLinks = new WeakSet();

  const disableTabLinks = () => {
    // MegaMenuCategory__TabLinkクラスを持つすべてのaタグを取得
    const tabLinks = document.querySelectorAll("a.MegaMenuCategory__TabLink");

    tabLinks.forEach((link) => {
      // 既に処理済みのリンクはスキップ
      if (processedTabLinks.has(link)) return;

      link.addEventListener(
        "click",
        (e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        },
        { once: false }
      );

      // 視覚的にリンクが無効であることを示す
      link.style.cursor = "default";
      link.style.pointerEvents = "none";

      // 処理済みとしてマーク
      processedTabLinks.add(link);
    });
  };

  // 初期実行
  disableTabLinks();

  // 動的に追加される要素にも対応（MutationObserver）
  const tabLinkObserver = new MutationObserver(() => {
    disableTabLinks();
  });

  tabLinkObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// cart-count要素の括弧を保持する処理
!(function () {
  function updateCartCountWithParentheses(element) {
    // 無限ループを防ぐためのフラグをチェック
    if (element.dataset.updating === "true") {
      return;
    }

    // 現在のHTML内容を取得
    const currentHTML = element.innerHTML.trim();

    // 既に括弧が含まれている場合はスキップ
    if (currentHTML.includes("<span") && currentHTML.includes("(") && currentHTML.includes(")</span>")) {
      return;
    }

    // 現在のテキスト内容を取得
    const currentText = element.textContent.trim();

    // 数値のみかどうかをチェック（括弧がない場合）
    const numericMatch = currentText.match(/^\d+$/);

    if (numericMatch) {
      // 更新フラグを設定
      element.dataset.updating = "true";

      // 数値のみの場合は括弧を追加（括弧には色を指定しない）
      const count = numericMatch[0];
      element.innerHTML = `<span class="cart-count-parenthesis">(</span>${count}<span class="cart-count-parenthesis">)</span>`;

      // フラグを解除
      setTimeout(function () {
        element.dataset.updating = "false";
      }, 0);
    } else {
      // 数値が含まれている場合は括弧を追加
      const count = currentText.replace(/[^\d]/g, "") || "0";
      if (count) {
        element.dataset.updating = "true";
        element.innerHTML = `<span class="cart-count-parenthesis">(</span>${count}<span class="cart-count-parenthesis">)</span>`;
        setTimeout(function () {
          element.dataset.updating = "false";
        }, 0);
      }
    }
  }

  function initializeCartCounts() {
    const cartCountElements = document.querySelectorAll("cart-count.header__cart-count");

    cartCountElements.forEach((element) => {
      updateCartCountWithParentheses(element);
    });
  }

  // MutationObserverでcart-count要素の変更を監視
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList" || mutation.type === "characterData") {
        const target = mutation.target;
        if (target.tagName === "CART-COUNT" && target.classList.contains("header__cart-count")) {
          updateCartCountWithParentheses(target);
        } else if (target.parentElement && target.parentElement.tagName === "CART-COUNT") {
          updateCartCountWithParentheses(target.parentElement);
        }
      }
    });
  });

  function observeCartCounts() {
    const cartCountElements = document.querySelectorAll("cart-count.header__cart-count");

    cartCountElements.forEach((element) => {
      observer.observe(element, {
        childList: true,
        characterData: true,
        subtree: true,
      });
      updateCartCountWithParentheses(element);
    });
  }

  // カート更新イベントをリッスン（バックアップとして）
  document.addEventListener("cart:updated", function (event) {
    setTimeout(function () {
      initializeCartCounts();
    }, 10);
  });

  // カートリフレッシュイベントをリッスン（バックアップとして）
  document.addEventListener("cart:refresh", function (event) {
    setTimeout(function () {
      initializeCartCounts();
    }, 10);
  });

  // DOMContentLoadedで初期化
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(observeCartCounts, 100);
    });
  } else {
    setTimeout(observeCartCounts, 100);
  }

  // 動的に追加される要素にも対応
  const bodyObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          const cartCounts = node.querySelectorAll ? node.querySelectorAll("cart-count.header__cart-count") : [];
          cartCounts.forEach(function (element) {
            observer.observe(element, {
              childList: true,
              characterData: true,
              subtree: true,
            });
            updateCartCountWithParentheses(element);
          });
        }
      });
    });
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

// 商品一覧ページ：カラーバリエーション画像に切り替えた後、サムネイルhover時にメイン画像に戻す
!(function () {
  function initProductItemImageHover() {
    const productItems = document.querySelectorAll("product-item");

    productItems.forEach((productItem) => {
      // 既に初期化済みの場合はスキップ
      if (productItem.dataset.imageHoverInitialized === "true") {
        return;
      }

      const imageWrapper = productItem.querySelector(".product-item__image-wrapper");
      const primaryImageList = Array.from(productItem.querySelectorAll(".product-item__primary-image"));

      if (!imageWrapper || primaryImageList.length === 0) return;

      // メイン画像を取得（data-main-image="true"の画像）
      const mainImage = primaryImageList.find((img) => img.getAttribute("data-main-image") === "true");
      if (!mainImage) return;

      // クリックしたカラーバリエーション画像を保存する変数
      let clickedVariantImage = null;

      // カラースウォッチクリック時に画像を保存
      const swatchRadios = productItem.querySelectorAll(".product-item-meta__swatch-list .color-swatch__radio");
      swatchRadios.forEach((radio) => {
        radio.addEventListener("change", () => {
          // theme.jsの画像切り替え処理が完了した後に、クリックした画像を保存
          setTimeout(() => {
            const displayedImage = primaryImageList.find((img) => !img.hasAttribute("hidden"));
            if (displayedImage && displayedImage !== mainImage) {
              clickedVariantImage = displayedImage;
            }
          }, 600); // theme.jsのアニメーション完了後に更新
        });
      });

      // 画像ラッパーにhoverした時の処理
      imageWrapper.addEventListener("mouseenter", () => {
        // 現在表示中の画像を取得（hidden属性がない画像）
        const currentImage = primaryImageList.find((img) => !img.hasAttribute("hidden"));

        // メイン画像以外が表示されている場合、メイン画像に戻す
        if (currentImage && currentImage !== mainImage) {
          // 現在の画像を保存（hoverを外した時に戻すため）
          if (!clickedVariantImage || clickedVariantImage === mainImage) {
            clickedVariantImage = currentImage;
          }
          currentImage.setAttribute("hidden", "");
          mainImage.removeAttribute("hidden");
        }
      });

      // 画像ラッパーからhoverが外れた時の処理
      imageWrapper.addEventListener("mouseleave", () => {
        // クリックしたカラーバリエーション画像がある場合、その画像に戻す
        if (clickedVariantImage && clickedVariantImage !== mainImage) {
          const currentImage = primaryImageList.find((img) => !img.hasAttribute("hidden"));
          if (currentImage === mainImage) {
            mainImage.setAttribute("hidden", "");
            clickedVariantImage.removeAttribute("hidden");
          }
        }
      });

      // 初期化済みフラグを設定
      productItem.dataset.imageHoverInitialized = "true";
    });
  }

  // DOMContentLoadedで初期化
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(initProductItemImageHover, 100);
    });
  } else {
    setTimeout(initProductItemImageHover, 100);
  }

  // 動的に追加される要素にも対応
  const observer = new MutationObserver(() => {
    initProductItemImageHover();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();


  // 260121追加　LOOKポップアップ
document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.querySelector('.js-video-trigger');
  const modal = document.getElementById('video-modal');
  const iframe = modal.querySelector('iframe');
  const close = modal.querySelector('.video-modal__close');

  if (!trigger || !modal) return;

  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    const videoUrl = this.dataset.videoUrl;
    if (!videoUrl) return;

    iframe.src = videoUrl;
    modal.classList.add('is-open');
  });

  close.addEventListener('click', function () {
    modal.classList.remove('is-open');
    iframe.src = '';
  });
});



